/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "oTahLEX3NXo",
    title: "What is Notion?",
    description: "Notion is a single space where you can think, write, and plan. Capture thoughts, manage projects, or even run an entire company — and do it exactly the way you want.",
    creator: "Notion",
    categoryName: "notion",
  },
  {
    _id: "IrIAmq80VEE",
    title: "Notion App: Full Notion Tutorial for Beginners",
    creator: "Productive Dude",
    categoryName: "notion",
    description:
      "This is the only Notion tutorial you will need for 2022. In this video I go over everything you need to know about Notion. ",
  },

  {
    _id: "jAQFnnfxDmw",
    title: "Notion Masterclass: Personal Dashboard",
    creator: "Thomas Frank",
    categoryName: "notion",
    description:
      "In this video you will learn how to make your own personal dashboard in Notion from scratch. ",
  },
  {
    _id: "qj9HeT-IaEg",
    title: "My Notion Note-Taking System",
    creator: "Thomas Frank",
    categoryName: "notion",
    description:
      "How well does Notion work as a note-taking app? In this video, I'll show you my take on the ultimate note-taking system within Notion.",
  },
  {
    _id: "QgbLb6QCK88",
    title: "How to Use the Obsidian App for Notes",
    creator: "Linking Your Thinking",
    categoryName: "obsidian",
    description:
      "This is lesson 1 for beginners. This is the ultimate Obsidian HOW TO. Learn how to supercharge your note-taking and note-making"
  },
  {
    _id: "SBskOKpXsTA",
    title: "How I use Obsidian early 2022s",
    creator: "Danny Hatcher",
    categoryName: "obsidian",
    description:
      "How I am using Obsidian for my knowledge management at the beginning of 2022.",
  },
  {
    _id: "GUtXbwqS3iQ",
    title: "How To Organize Your Notes in Obsidian",
    creator: "Filipe Donadio",
    categoryName: "obsidian",
    description:
      "In this video we talk about the different ways to organize notes in Obsidian, using folders, tags, and links.",
  },
  {
    _id: "BhHfF0P9A80",
    title: "How I Use Logseq to Take Notes and Organize My Life",
    creator: "Shu Omi",
    categoryName: "logSeq",
    description:
      "Learn everything you need to learn about LogSeq for note taking.",
  },
  {
    _id: "bMKsvo2mE_0",
    title: "Ramses Oudt: Networked Thinking Using Logseq",
    creator: "Tiago Forte",
    categoryName: "logSeq",
    description:
      "In this video, Ramses, Community Manager at Logseq, shows the basics of networked thinking using the outlining tool Logseq.",
  },
  {
    _id: "rOSZOCoqOo8",
    title: "Zettelkasten Note-Taking Method: Simply Explained",
    creator: "Shu Omi",
    categoryName: "techniques",
    description:
      "Zettelkasten method is a powerful knowledge management system, developed by Niklas Luhmann, a German sociologist.",
  },

  {
    _id: "HJ0dC82mZZE",
    title: "August Bradley: A Systems Thinking Approach",
    creator: "Tiago Forte",
    categoryName: "techniques",
    description:
      "In this session, we will explore the purpose and value of creating a Life Operating System, how it can be informed by Systems Thinking, and how to implement it along with Personal Knowledge Management",
  },


];
